var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-js-responsive-container vjs-hd"},[_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"controls":"","preload":"auto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }